import { Route } from 'react-router-dom';
import NewOrderLayout from 'OrderLayout/NewOrderLayout';
import { SpeciesSelection } from '@pages/OrderCreation/SpeciesSelection';
import SpeciesDetails from '@pages/NewOrderCreation/SpeciesDetails';
import { FrontendRoutes } from '@helpers/Constants/Navigation';
import { CreditAmountProvider } from '@contexts/CreditAmountContext';
import CartLayout from 'OrderLayout/CartLayout';

/**
 * Routes for creating a new order.
 *
 * Base Path: /create-order/
 *
 * Route Structure:
 * - /create-order/ → Displays the SpeciesSelection page where users choose a species.
 * - /create-order/species/customize → Opens the SpeciesDetails page to customize the selected species.
 *
 * The NewOrderLayout component acts as the layout wrapper for all create-order pages.
 */
export const newOrderRoutes = (
  <Route
    path={FrontendRoutes.CREATE_ORDER}
    element={
      <CreditAmountProvider>
        <NewOrderLayout />
      </CreditAmountProvider>
    }
  >
    <Route index element={<SpeciesSelection />} />
    <Route
      path={FrontendRoutes.CREATE_ORDER_SPECIES_CUSTOMISATION_V2}
      element={<SpeciesDetails />}
    />
    <Route path={FrontendRoutes.CART} element={<CartLayout />} />
  </Route>
);
